{
    "0": {
        "en-CA": "Not applicable",
        "fr-CA": "Sans objet"
    },
    "1": {
        "en-CA": "Not eligible",
        "fr-CA": "Non admissible"
    },
    "2": {
        "en-CA": "Eligible",
        "fr-CA": "Admissible"
    },
    "3": {
        "en-CA": "Accepted",
        "fr-CA": "Accepté"
    },
    "4": {
        "en-CA": "Rejected",
        "fr-CA": "Rejeté"
    }
}
